import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class InsuranceProxy extends ProxyBase {
  postLiquidityAndSolvencyAndCoverAge(params) {
    return this.post('LiquidityAndSolvencyAndCoverAge', params)
  }
  downloadLiquiditySolvencyCoverage(params) {
    return this.post(
      'LiquidityAndSolvencyAndCoverAge/Export',
      params,
      {},
      'download',
    )
  }
  postProfitability(params) {
    return this.post('Profitability', params)
  }
  downloadProfitability(params) {
    return this.post('Profitability/Export', params, {}, 'download')
  }
  postBusinessGrowth(params) {
    return this.post('BusinessGrowth', params)
  }
  downloadBusinessGrowth(params) {
    return this.post('BusinessGrowth/Export', params, {}, 'download')
  }
}

export default new InsuranceProxy('IndustryAnalysis/')
